import React, { Fragment } from "react";

import { splitPrice } from "@utils/productPrice";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./conversion.scss";

type Props = {
    currentConversionPrice: number | null;
    currentPrice: number;
    conversionUnit: string | null;
    showConvertedPriceAsMainPrice: boolean;
};

const Conversion = ({
    conversionUnit,
    currentConversionPrice,
    showConvertedPriceAsMainPrice,
    currentPrice,
}: Props) => {
    const { t } = useGranite();
    const conversionTk = t("ecommerce.label.productUnit");

    const getPrice = () => {
        let price = undefined;
        let conversion = undefined;

        if (conversionUnit !== null && !showConvertedPriceAsMainPrice) {
            price = currentConversionPrice;
            conversion = conversionUnit;
        }

        if (showConvertedPriceAsMainPrice) {
            price = currentPrice;
            conversion = conversionTk;
        }

        if (price && conversion) {
            return `${splitPrice(price)[0]},${
                splitPrice(price)[1]
            }/${conversion}`;
        }
    };

    const showPrice = !!getPrice();

    return (
        <Fragment>
            {showPrice && (
                <div className="pricing-conversion row d-flex justify-content-end">
                    {getPrice()}
                </div>
            )}
        </Fragment>
    );
};

export default Conversion;
